import * as EmailValidator from "email-validator";
import FileInputFormValidatedVue from "componentsShared/Inputs/File/FileInputFormValidated.vue";
import SvgIconBookWithPen from "componentsShared/SvgIcons/SvgIconBookWithPen.vue";
export default {
  data: function data() {
    return {
      form: {
        email: null,
        title: null,
        text: null,
        attachment: null
      },
      formSend: false
    };
  },
  components: {
    "v-file-input-form-validated": FileInputFormValidatedVue,
    "v-svg-icon-book-with-pen": SvgIconBookWithPen
  },
  props: ["initialData"],
  methods: {
    // Zpět = návrat na předchozí stránku; bez interní historie (přímý vstup, nový tab, příchod z IdP) nechá proběhnout href na dashboard.
    goBack: function goBack(e) {
      if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
      if (window.history.length > 1 && document.referrer.startsWith(window.location.origin + "/")) {
        e.preventDefault();
        window.history.back();
      }
    },
    sendForm: function sendForm(e) {
      var _this = this;
      e.preventDefault();
      if (!this.formIsValid) return;
      var component = this;
      var formData = new FormData();
      formData.append("email", component.form.email);
      formData.append("title", component.form.title);
      formData.append("text", component.form.text);
      if (component.form.attachment) formData.append("attachment", component.form.attachment);
      component.axios.post("/Contact/SendMessage", formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }).then(function () {
        component.$toast.success("Zpráva odeslána.", {
          duration: 2000
        });
        _this.formSend = true;
      }).catch(function (error) {
        var _error$response;
        var code = error === null || error === void 0 || (_error$response = error.response) === null || _error$response === void 0 || (_error$response = _error$response.data) === null || _error$response === void 0 ? void 0 : _error$response.error;
        if (code === "attachment_too_large") {
          component.$toast.error(component.$t("contact_form.attachment_too_large"), {
            duration: 4000
          });
        } else if (code === "attachment_type_not_allowed") {
          component.$toast.error(component.$t("contact_form.attachment_type_not_allowed"), {
            duration: 4000
          });
        } else {
          console.error(error);
        }
      });
    }
  },
  computed: {
    emailIsValid: function emailIsValid() {
      return EmailValidator.validate(this.form.email) && this.form.email !== null;
    },
    titleIsValid: function titleIsValid() {
      return this.form.title !== null && this.form.title.length > 0;
    },
    formIsValid: function formIsValid() {
      return this.emailIsValid && this.titleIsValid;
    }
  }
};